import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class SuiviService {
	constructor(private http: HttpClient) { }

	set(
		id: any,
		dossierid: any,
		typeId: any,
		options: any = []
	): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.suivi:set',
			params: {
				id: id,
				dossierid: dossierid,
				typeid: typeId,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	get(dossierid: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.suivi:get',
			params: {
				dossierid: dossierid,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getSuiviTypeList(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.suivi:getSuiviTypeList',
			params: {},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getAllSuvis(dossierid: any, options = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.suivi:getAllSuvis',
			params: {
				dossierid: dossierid,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	addOrigineToSuivi(ID: any, suivis: any, options = {}): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.suivi:addOrigineToSuivi',
			params: {
				ID: ID,
				suivis: suivis,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getSuivisBy(demandeFormulaireID: any, options: any = null): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.suivi:getSuivisBy',
			params: {
				ID: demandeFormulaireID,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	removeSuiviFrom(ID: any, suiviID: any, options: any = null): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.suivi:removeSuiviFrom',
			params: {
				ID: ID,
				suiviID: suiviID,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setOrigine(suiviID: any, origine: any, options: any[] = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.suivi:setOrigine',
			params: {
				suiviID: suiviID,
				origine: origine,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

}
